<template>
  <div
    :class="{'laptop:mt-100px mt-10 md:mt-16': !compact}"
    :style="'background-color: '+bandColor"
  >
    <slot />
  </div>
</template>

<script lang="ts">
// import LazyComponent from 'v-lazy-component/vue2'
export default defineNuxtComponent({
  name: 'BlockBand',
  // components: { LazyComponent },
  props: {
    compact: { type: Boolean, default: false },
    bandColor: { type: String, default: null }
  }
})
</script>

<style scoped>

</style>
